<template>
  <v-container fluid>
    <!-- เสนอรายยชื่อ ศึกษานิเทศก์หรือผู้ทรงคุณวุฒิ เพื่อจัดทำบัญชีประเมินครูผู้ช่วย -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card urgent-mission "
        v-if="period_colleges_committee.period_college_enable === '1'"
      >
        <div class="mission-stripe urgent"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="error" outlined size="small">
                    <v-icon left small>mdi-bell-ring</v-icon>
                    ประกาศสำคัญ
                  </v-chip>
                  <v-chip color="warning" size="small" class="ml-2">
                    <v-icon left small>mdi-alert</v-icon>
                    เร่งด่วน
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="primary" class="mr-3">mdi-school</v-icon>
                  เสนอรายยชื่อ ศึกษานิเทศก์หรือผู้ทรงคุณวุฒิ
                  เพื่อจัดทำบัญชีประเมินครูผู้ช่วย
                </h2>
                <h3>
                  ให้สถานศึกษา เสนอรายชื่อ ศึกษานิเทศก์หรือผู้ทรงคุณวุฒิ
                </h3>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="error">mdi-clock-alert</v-icon>
                    ปิดระบบวันที่
                  </h4>
                  <div class="deadline-date">
                    {{
                      dateToThai(period_colleges_committee.period_college_stop)
                    }}
                  </div>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_colleges_committee.period_college_stop +
                        ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ (ที่ไม่ใช่ใบประกอบวิชาชีพทางการศึกษา) ของตำแหน่ง ครูผู้ช่วย -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card urgent-mission "
        v-if="period_colleges_teach_license.period_college_enable === '1'"
      >
        <div class="mission-stripe urgent"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="error" outlined size="small">
                    <v-icon left small>mdi-bell-ring</v-icon>
                    ประกาศสำคัญ
                  </v-chip>
                  <v-chip color="warning" size="small" class="ml-2">
                    <v-icon left small>mdi-alert</v-icon>
                    เร่งด่วน
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="primary" class="mr-3">mdi-school</v-icon>
                  สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ
                  (ที่ไม่ใช่ใบประกอบวิชาชีพทางการศึกษา) ของตำแหน่ง ครูผู้ช่วย
                </h2>
                <h3>
                  ให้สถานศึกษา เร่งสำรวจและตรวจสอบ ใบอนุญาตประกอบวิชาชีพเฉพาะ
                </h3>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="error">mdi-clock-alert</v-icon>
                    ปิดระบบวันที่
                  </h4>
                  <div class="deadline-date">
                    {{
                      dateToThai(
                        period_colleges_teach_license.period_college_stop
                      )
                    }}
                  </div>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_colleges_teach_license.period_college_stop +
                        ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- ประกาศรายชื่อ ผู้ผ่านคุณสมบัติ รองผู้อำนวยการ -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card urgent-mission "
        v-if="period_sedirector_notice.period_sedirector_enable === '1'"
      >
        <div class="mission-stripe urgent"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="error" outlined size="small">
                    <v-icon left small>mdi-bell-ring</v-icon>
                    ประกาศสำคัญ
                  </v-chip>
                  <v-chip color="warning" size="small" class="ml-2">
                    <v-icon left small>mdi-alert</v-icon>
                    เร่งด่วน
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="primary" class="mr-3">mdi-school</v-icon>
                  รายชื่อผู้มีสิทธิเข้ารับการคัดเลือก
                </h2>

                <h3 class="mission-subtitle mb-3">
                  ตำแหน่ง
                  <span class="highlight-text">รองผู้อำนวยการสถานศึกษา</span>
                </h3>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="info" class="mr-2"
                      >mdi-information</v-icon
                    >
                    <span>ผู้สมัครและวิทยาลัยสามารถตรวจสอบข้อมูลผ่านระบบ</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="warning" class="mr-2"
                      >mdi-alert</v-icon
                    >
                    <span class="text-warning"
                      >เฉพาะวิทยาลัยที่ปรากฎผู้สมัคร</span
                    >
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="error">mdi-clock-alert</v-icon>
                    ปิดระบบวันที่
                  </h4>
                  <div class="deadline-date">
                    {{
                      dateToThai(
                        period_sedirector_notice.period_sedirector_stop
                      )
                    }}
                  </div>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_sedirector_notice.period_sedirector_stop +
                        ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- วิทยาลัยประเมิน ภาค ก ตำแหน่ง รองผู้อำนวยการ -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card evaluation-mission "
        v-if="period_college_assistantA.period_college_enable === '1'"
      >
        <div class="mission-stripe evaluation"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="orange" outlined size="small">
                    <v-icon left small>mdi-clipboard-check</v-icon>
                    งานประเมิน
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="orange" class="mr-3">mdi-star-box</v-icon>
                  ประเมิน ภาค ก ตำแหน่ง รองผู้อำนวยการ
                </h2>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-calendar-check</v-icon
                    >
                    <span
                      >ให้วิทยาลัยดำเนินการก่อนระบบปิดในวันที่
                      <strong class="text-error">
                        {{
                          dateToThai(
                            period_college_assistantA.period_college_stop
                          )
                        }}
                      </strong>
                    </span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="warning" class="mr-2"
                      >mdi-alert</v-icon
                    >
                    <span class="text-warning"
                      >เฉพาะวิทยาลัยที่ปรากฎผู้สมัคร</span
                    >
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="orange">mdi-clock-outline</v-icon>
                    เหลือเวลาอีก
                  </h4>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_college_assistantA.period_college_stop +
                        ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- วิทยาลัยรับรายงานตัว รองผู้อำนวยการ -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card reporting-mission "
        v-if="period_college_redirector.period_college_enable === '1'"
      >
        <div class="mission-stripe reporting"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="success" outlined size="small">
                    <v-icon left small>mdi-account-check</v-icon>
                    รับรายงานตัว
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="success" class="mr-3"
                    >mdi-clipboard-account</v-icon
                  >
                  รับรายงานตัว รองผู้อำนวยการ
                </h2>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-calendar-check</v-icon
                    >
                    <span
                      >ให้วิทยาลัยดำเนินการก่อนระบบปิดในวันที่
                      <strong class="text-error">
                        {{
                          dateToThai(
                            period_college_redirector.period_college_stop
                          )
                        }}
                      </strong>
                    </span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="warning" class="mr-2"
                      >mdi-alert</v-icon
                    >
                    <span class="text-warning"
                      >เฉพาะวิทยาลัยที่ได้รับรองผู้อำนวยการวิทยาลัย</span
                    >
                  </div>
                </div>

                <div class="action-section mt-4">
                  <v-btn
                    @click="viewDatasecDirect()"
                    color="success"
                    class="action-btn"
                    rounded
                    large
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    ตรวจสอบรายชื่อ
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="success">mdi-timer</v-icon>
                    เหลือเวลาอีก
                  </h4>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_college_redirector.period_college_stop +
                        ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- รับรายงานตัว ย้ายกรณีปกติ -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card transfer-mission "
        v-if="
          period_colleges_reportmv.period_college_enable === '1' &&
            period_colleges_reportmv.period_college_type ===
              'reportmove_teacher'
        "
      >
        <div class="mission-stripe transfer"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="indigo" outlined size="small">
                    <v-icon left small>mdi-swap-horizontal</v-icon>
                    การย้าย
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="indigo" class="mr-3"
                    >mdi-account-arrow-right</v-icon
                  >
                  รับรายงานตัว ย้ายกรณีปกติ
                </h2>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-calendar-check</v-icon
                    >
                    <span
                      >ให้วิทยาลัยดำเนินการก่อนระบบปิดในวันที่
                      <strong class="text-error">
                        {{
                          dateToThai(
                            period_colleges_reportmv.period_college_stop
                          )
                        }}
                      </strong>
                    </span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="warning" class="mr-2"
                      >mdi-alert</v-icon
                    >
                    <span class="text-warning"
                      >เฉพาะวิทยาลัยที่ได้รับครูจากการย้ายกรณีปกติตามประกาศ</span
                    >
                  </div>
                </div>

                <div class="action-section mt-4">
                  <v-btn
                    @click="viewDataMoveTeach()"
                    color="indigo"
                    class="action-btn"
                    rounded
                    large
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    ตรวจสอบรายชื่อ
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="indigo">mdi-clock-outline</v-icon>
                    เหลือเวลาอีก
                  </h4>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_colleges_reportmv.period_college_stop + ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- รายงานอัตรากำลัง -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card manpower-mission "
        v-if="
          period_colleges.period_college_enable === '1' &&
            period_colleges.period_college_type === 'update_college'
        "
      >
        <div class="mission-stripe manpower"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="7">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="purple" outlined size="small">
                    <v-icon left small>mdi-account-group</v-icon>
                    อัตรากำลัง
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="purple" class="mr-3">mdi-chart-bar</v-icon>
                  รายงานอัตรากำลัง
                </h2>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-calendar-check</v-icon
                    >
                    <span
                      >ให้วิทยาลัยดำเนินการก่อนระบบปิดในวันที่
                      <strong class="text-error">
                        {{ dateToThai(period_colleges.period_college_stop) }}
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="5">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="purple">mdi-clock-outline</v-icon>
                    ปิดระบบงานอัตรากำลัง
                  </h4>
                  <div class="deadline-date">
                    {{ dateToThai(period_colleges.period_college_stop) }}
                  </div>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_colleges.period_college_stop + ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- แจ้งสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card vacancy-mission "
        v-if="period_colleges_manpower.period_college_enable === '1'"
      >
        <div class="mission-stripe vacancy"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="7">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="teal" outlined size="small">
                    <v-icon left small>mdi-briefcase-outline</v-icon>
                    ตำแหน่งว่าง
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="teal" class="mr-3">mdi-clipboard-text</v-icon>
                  แจ้งสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง
                </h2>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-calendar-check</v-icon
                    >
                    <span
                      >ให้วิทยาลัยดำเนินการก่อนระบบปิดในวันที่
                      <strong class="text-error">
                        {{
                          dateToThai(
                            period_colleges_manpower.period_college_stop
                          )
                        }}
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="5">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="teal">mdi-clock-outline</v-icon>
                    ปิดระบบงานอัตรากำลัง
                  </h4>
                  <div class="deadline-date">
                    {{
                      dateToThai(period_colleges_manpower.period_college_stop)
                    }}
                  </div>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="
                      period_colleges_manpower.period_college_stop + ' 16:30:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- แจ้งสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง พนักงานราชการ-->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card vacancy-mission "
        v-if="period_govem.period_college_enable === '1'"
      >
        <div class="mission-stripe vacancy"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="7">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="teal" outlined size="small">
                    <v-icon left small>mdi-briefcase-outline</v-icon>
                    ตำแหน่งว่าง
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="teal" class="mr-3">mdi-clipboard-text</v-icon>
                  สถานศึกษา สถาบันฯ สำรวจตำแหน่งว่าง พนักงานราชการ
                </h2>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-calendar-check</v-icon
                    >
                    <span
                      >ให้ดำเนินการก่อนระบบปิดในวันที่
                      <strong class="text-error">
                        {{ dateToThai(period_govem.period_college_stop) }}
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="5">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="teal">mdi-clock-outline</v-icon>
                    ปิดระบบ
                  </h4>
                  <div class="deadline-date">
                    {{ dateToThai(period_govem.period_college_stop) }}
                  </div>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="period_govem.period_college_stop + ' 23:59:59'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- รายงานตัวครูผู้ช่วย -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card assistant-mission"
        v-if="periodassteachs.periodAssTeachEnable === '1'"
      >
        <div class="mission-stripe assistant"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="cyan" outlined size="small">
                    <v-icon left small>mdi-account-tie</v-icon>
                    ครูผู้ช่วย
                  </v-chip>
                </div>

                <h2 class="mission-title">
                  <v-icon color="cyan" class="mr-3">mdi-school-outline</v-icon>
                  ดำเนินการ รับรายงานตัว ครูผู้ช่วย
                </h2>

                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-calendar-check</v-icon
                    >
                    <span
                      >ก่อนระบบปิดในวันที่
                      <strong class="text-error">
                        {{ dateToThai(periodassteachs.periodAssTeachStop) }}
                      </strong>
                      เวลา 16:30:00 น.
                    </span>
                  </div>
                </div>

                <div class="action-section mt-4">
                  <v-btn
                    @click="viewData()"
                    color="cyan"
                    class="action-btn"
                    rounded
                    large
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    ตรวจสอบรายชื่อ
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="cyan">mdi-timer</v-icon>
                    ปิดระบบรับรายงานตัว ครูผู้ช่วย
                  </h4>
                  <div class="deadline-date">
                    {{ dateToThai(periodassteachs.periodAssTeachStop) }}
                  </div>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="periodassteachs.periodAssTeachStop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- Dialog Components -->
    <Manage_assistant_teacher
      v-bind:OpenDialog_manage_assistant_teacher="
        OpenDialog_manage_assistant_teachers
      "
      @toggle-favorite="receiveEmit"
    />

    <Conditons_transfer_success_Vue
      v-bind:OpenDialog_conditons_transfer_success="
        OpenDialog_conditons_transfer_successs
      "
      @toggle-favorite="receiveEmit"
    />

    <Sedirector_app
      v-bind:OpenDialog_sedirector_app="OpenDialog_sedirector_apps"
      @toggle-favorite="receiveEmit"
    />
  </v-container>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";
import Manage_assistant_teacher from "./manage_assistant_teacher.vue";
import Conditons_transfer_success_Vue from "./conditons_transfer_success.vue";
import Sedirector_app from "./sedirector_app.vue";

export default {
  name: "HRvecAlertMissionCollege",
  components: {
    FlipCountdown,
    Manage_assistant_teacher,
    Conditons_transfer_success_Vue,
    Sedirector_app
  },

  data() {
    return {
      ApiKey: "HRvec2021",
      period_colleges: [],
      period_colleges_reportmv: [],
      period_colleges_manpower: [],
      period_teacher_requests: [],
      period_college_moves: [],
      period_college_moves_attactment: [],
      period_teacher_moves: [],
      perioddiscuss: [],
      periodassteachs: [],
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },
      period_college_redirector: [],
      period_college_assistantA: [],
      OpenDialog_manage_assistant_teacher: "",
      OpenDialog_manage_assistant_teachers: "",
      OpenDialog_conditons_transfer_success: "",
      OpenDialog_conditons_transfer_successs: "",
      OpenDialog_sedirector_app: "",
      OpenDialog_sedirector_apps: "",
      period_sedirector_notice: [],
      period_govem: [],
      period_colleges_teach_license: [],
      period_colleges_committee: [] 
    };
  },

  async mounted() {
    await this.period_collegeAssTeach_licenseQuery();
    await this.period_collegeQuery();
    await this.period_collegemvQuery();
    await this.teacher_requestQuery();
    await this.period_college_moveQuery();
    await this.period_teacher_moveQuery();
    await this.periodDiscussQuery();
    await this.periodassteach();
    await this.period_collegeSedirectors();
    await this.period_college_move_attactment();
    await this.period_collegeSedirectors_assistantA();
    await this.period_collegeSedirectors_Notice();
    await this.period_college_manpowerQuery();
    await this.period_govemQuery();
    await this.period_colleges_committeeQuery();

    this.OpenDialog_manage_assistant_teachers = false;
    this.OpenDialog_conditons_transfer_successs = false;
  },

  filters: {
    moment: function(date, operation, value) {
      if (!date) return "";

      if (operation === "add" && value === "543 years") {
        return {
          moment: function(format) {
            const d = new Date(date);
            d.setFullYear(d.getFullYear() + 543);
            if (format === "D MMMM YYYY") {
              return d.toLocaleDateString("th-TH", {
                day: "numeric",
                month: "long",
                year: "numeric"
              });
            }
            return d.toLocaleDateString("th-TH");
          }
        };
      }
      return date;
    }
  },

  methods: {
    async period_colleges_committeeQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "60101"
      });
      this.period_colleges_committee = result_period_college.data;
    },  
    dateToThai(dateString, format = "full") {
      const date = new Date(dateString);

      // เพิ่ม 543 ปี สำหรับปีพุทธศักราช
      const thaiYear = date.getFullYear() + 543;

      // ชื่อเดือนภาษาไทย
      const thaiMonths = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];

      // ชื่อเดือนสั้น
      const thaiMonthsShort = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ];

      // ชื่อวันภาษาไทย
      const thaiDays = [
        "อาทิตย์",
        "จันทร์",
        "อังคาร",
        "พุธ",
        "พฤหัสบดี",
        "ศุกร์",
        "เสาร์"
      ];

      const day = date.getDate();
      const month = date.getMonth();
      const dayOfWeek = date.getDay();

      switch (format) {
        case "full":
          // วันจันทร์ที่ 31 กรกฎาคม พ.ศ. 2568
          return `วัน${thaiDays[dayOfWeek]}ที่ ${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;

        case "short":
          // 31 ก.ค. 68
          return `${day} ${thaiMonthsShort[month]} ${String(thaiYear).slice(
            -2
          )}`;

        case "medium":
          // 31 กรกฎาคม 2568
          return `${day} ${thaiMonths[month]} ${thaiYear}`;

        case "date-only":
          // 31 กรกฎาคม พ.ศ. 2568
          return `${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;

        case "with-day":
          // จันทร์ 31 กรกฎาคม 2568
          return `${thaiDays[dayOfWeek]} ${day} ${thaiMonths[month]} ${thaiYear}`;

        case "buddhist-era":
          // 31/07/2568
          return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(
            2,
            "0"
          )}/${thaiYear}`;

        case "christian-era":
          // 31/07/2025
          return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(
            2,
            "0"
          )}/${date.getFullYear()}`;

        default:
          return `${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;
      }
    },
    async viewDatasecDirect() {
      this.OpenDialog_sedirector_apps = true;
      this.OpenDialog_sedirector_app = this.OpenDialog_sedirector_apps;
    },

    async viewDataMoveTeach() {
      this.OpenDialog_conditons_transfer_successs = true;
      this.OpenDialog_conditons_transfer_success = this.OpenDialog_conditons_transfer_successs;
    },

    async viewData() {
      this.OpenDialog_manage_assistant_teachers = true;
      this.OpenDialog_manage_assistant_teacher = this.OpenDialog_manage_assistant_teachers;
    },

    async receiveEmit() {
      this.OpenDialog_manage_assistant_teachers = false;
      this.OpenDialog_conditons_transfer_successs = false;
      this.OpenDialog_sedirector_apps = false;
    },

    // API Methods (keeping original logic)
    async period_college_manpowerQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "701"
      });
      this.period_colleges_manpower = result_period_college.data;

      if (this.period_colleges_manpower.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_colleges_manpower.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async period_govemQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "801"
      });
      this.period_govem = result_period_college.data;
    },

    async period_collegeAssTeach_licenseQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "601"
      });
      this.period_colleges_teach_license = result_period_college.data;

      if (this.period_colleges_teach_license.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_colleges_teach_license.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async period_collegeQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "501"
      });
      this.period_colleges = result_period_college.data;

      if (this.period_colleges.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_colleges.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async period_collegeSedirectors() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "20101"
      });
      this.period_college_redirector = result_period_college.data;

      if (this.period_college_redirector.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_college_redirector.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async period_collegeSedirectors_Notice() {
      let result;
      result = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "202"
      });
      this.period_sedirector_notice = result.data;
    },

    async period_collegeSedirectors_assistantA() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "20100"
      });
      this.period_college_assistantA = result_period_college.data;
    },

    async period_collegemvQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "30102"
      });
      this.period_colleges_reportmv = result_period_college.data;

      if (this.period_colleges_reportmv.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_colleges_reportmv.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async teacher_requestQuery() {
      let result;
      result = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "30101"
      });
      this.period_teacher_requests = result.data;

      if (this.period_teacher_requests.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_teacher_requests.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async period_college_moveQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "401"
      });
      this.period_college_moves = result_period_college.data;

      if (this.period_college_moves.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_college_moves.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async period_college_move_attactment() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable_file: "1",
        period_college_type: "movement_college"
      });
      this.period_college_moves_attactment = result_period_college.data;

      if (
        this.period_college_moves_attactment.period_college_enable_file == "1"
      ) {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_college_moves_attactment.period_college_attactmentstop +
            " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async period_teacher_moveQuery() {
      let result_period_college;
      result_period_college = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "30103"
      });
      this.period_teacher_moves = result_period_college.data;

      if (this.period_teacher_moves.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.period_teacher_moves.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async periodDiscussQuery() {
      let result_period;
      result_period = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_enable: "1",
        period_college_id: "201"
      });
      this.perioddiscuss = result_period.data;

      if (this.perioddiscuss.period_college_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.perioddiscuss.period_college_stop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    },

    async periodassteach() {
      let result_period;
      result_period = await this.$http.post("periodassteach.php", {
        ApiKey: this.ApiKey,
        periodAssTeachEnable: "1",
        periodAssTeachID: "102"
      });
      this.periodassteachs = result_period.data;

      if (this.periodassteachs.periodAssTeachEnable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(
          this.periodassteachs.periodAssTeachStop + " 16:30:00"
        );
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
      }
    }
  }
};
</script>

<style scoped>
/* Dashboard Header */
.dashboard-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 25px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.dashboard-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="2" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="3" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.1)"/></svg>');
  pointer-events: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.header-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
}

/* Mission Cards */
.mission-card {
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.mission-card.card-hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.15) !important;
}

/* Mission Stripes */
.mission-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  z-index: 1;
}

.mission-stripe.urgent {
  background: linear-gradient(45deg, #ff6b6b, #ee5a52);
  animation: pulse-urgent 2s infinite;
}

.mission-stripe.evaluation {
  background: linear-gradient(45deg, #ff9800, #f57c00);
}

.mission-stripe.reporting {
  background: linear-gradient(45deg, #4caf50, #388e3c);
}

.mission-stripe.transfer {
  background: linear-gradient(45deg, #3f51b5, #303f9f);
}

.mission-stripe.manpower {
  background: linear-gradient(45deg, #9c27b0, #7b1fa2);
}

.mission-stripe.vacancy {
  background: linear-gradient(45deg, #009688, #00695c);
}

.mission-stripe.assistant {
  background: linear-gradient(45deg, #00bcd4, #0097a7);
}

@keyframes pulse-urgent {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

/* Mission Content */
.mission-content {
  padding-left: 20px;
}

.mission-badge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.mission-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
  line-height: 1.4;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.mission-subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  color: #34495e;
}

.highlight-text {
  background: linear-gradient(120deg, #a8edea 0%, #fed6e3 100%);
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 700;
  color: #2c3e50;
}

/* Mission Details */
.mission-details {
  margin-top: 1rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  font-size: 1rem;
  line-height: 1.6;
}

.detail-item:last-child {
  margin-bottom: 0;
}

/* Action Section */
.action-section {
  margin-top: 1.5rem;
}

.action-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  min-width: 180px;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

/* Countdown Container */
.countdown-container {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(
    135deg,
    rgba(103, 126, 234, 0.1) 0%,
    rgba(118, 75, 162, 0.1) 100%
  );
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.countdown-header {
  margin-bottom: 1.5rem;
}

.countdown-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.deadline-date {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 0.5rem;
}

.countdown-label {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.countdown-timer {
  margin: 1.5rem 0;
}

.countdown-timer >>> .flip-countdown {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.countdown-timer >>> .flip-countdown__piece {
  background: linear-gradient(145deg, #667eea, #764ba2) !important;
  color: white !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  font-size: 1.4rem !important;
  min-width: 60px !important;
  height: 60px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.85rem !important;
  color: #666 !important;
  margin-top: 8px !important;
  font-weight: 600 !important;
}

/* Text Utilities */
.text-warning {
  color: #f57c00 !important;
  font-weight: 600;
}

.text-error {
  color: #d32f2f !important;
  font-weight: 600;
}

.text-success {
  color: #388e3c !important;
  font-weight: 600;
}

.text-info {
  color: #1976d2 !important;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .header-title {
    font-size: 2.2rem;
  }

  .mission-title {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    padding: 2rem 1rem;
    border-radius: 15px;
  }

  .header-title {
    font-size: 1.8rem;
  }

  .header-subtitle {
    font-size: 1rem;
  }

  .mission-title {
    font-size: 1.3rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .action-btn {
    width: 100%;
    margin-top: 1rem;
  }

  .countdown-container {
    margin-top: 2rem;
    padding: 1.5rem;
  }

  .countdown-timer >>> .flip-countdown__piece {
    min-width: 50px !important;
    height: 50px !important;
    font-size: 1.2rem !important;
  }
}

@media (max-width: 600px) {
  .alert-mission-college-container {
    padding: 0.5rem;
  }

  .mission-card {
    margin-bottom: 1.5rem;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail-item .v-icon {
    margin-bottom: 4px;
  }

  .mission-badge {
    flex-direction: column;
    align-items: flex-start;
  }

  .countdown-timer >>> .flip-countdown {
    gap: 8px;
  }

  .countdown-timer >>> .flip-countdown__piece {
    min-width: 45px !important;
    height: 45px !important;
    font-size: 1rem !important;
  }
}

/* Animation Effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mission-card {
  animation: fadeInUp 0.6s ease-out;
}

.mission-card:nth-child(2) {
  animation-delay: 0.1s;
}
.mission-card:nth-child(3) {
  animation-delay: 0.2s;
}
.mission-card:nth-child(4) {
  animation-delay: 0.3s;
}
.mission-card:nth-child(5) {
  animation-delay: 0.4s;
}
.mission-card:nth-child(6) {
  animation-delay: 0.5s;
}
.mission-card:nth-child(7) {
  animation-delay: 0.6s;
}
.mission-card:nth-child(8) {
  animation-delay: 0.7s;
}

/* Vuetify Overrides */
.v-chip.v-chip--outlined {
  border-width: 2px !important;
  font-weight: 600 !important;
}

.v-btn {
  text-transform: none !important;
}

/* Focus States for Accessibility */
.action-btn:focus {
  outline: 3px solid rgba(25, 118, 210, 0.5);
  outline-offset: 2px;
}

.mission-card:focus-within {
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3);
}

/* Loading States */
.loading-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
